<template>
  <div id="ag-grid-demo">
    <!-- START FILTER BLOCK -->
    <div class="vx-col w-full mb-base">
      <div class="filter_container">
        <vx-card title="Sélection du client" class="mr-4 mb-0">
          <p>
            Sélectionner le client pour lequel vous souhaitez voir les
            statisques
          </p>
          <div class="vx-row">
            <div class="vx-col sm:w-full w-full mb-2">
              <vs-select
                autocomplete
                v-model="society"
                class="w-full select-large mt-4"
                label="Choisissez un client"
              >
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item.name"
                  v-for="(item, index) in allSocieties"
                  class="w-full"
                />
              </vs-select>
            </div>
          </div>
        </vx-card>
        <!-- SERP FILTER PART -->
        <vx-card title="Analyse SERP" v-if="selectedSociety">
          <p>
            Faites une analyse SERP en temps réelle pour un mot clé (5 à 15
            minutes)
          </p>

          <div class="vx-row">
            <!-- KEYWORD INPUT -->
            <div class="vx-col">
              <vs-input
                label="Mot clé"
                v-model="keyword"
                class="mt-4"
              ></vs-input>
            </div>
            <!-- ENGINE SELECTOR -->
            <div class="vx-col">
              <vs-select
                autocomplete
                v-model="searchEngine"
                class="w-full select-large mt-4"
                label="Choisissez un moteur de recherche"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in allSearchEngines"
                  class="w-full"
                />
              </vs-select>
            </div>
          </div>

          <div class="vx-row mt-4" v-if="searchEngine && keyword">
            <div class="vx-col">
              <vs-button
                color="primary"
                type="filled"
                class="mb-4 mr-4"
                @click="newSerp"
                >Lancer l'analyse</vs-button
              >
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <!-- END FILTER BLOCK -->

    <!-- UPDATE DATA LOADING BAR -->
    <div class="center" v-if="updateClick">
      <vx-card class="w-1/2">
        <div class="w-full">
          <p>
            Le rafraichissement des données peut prendre un certains temps vous
            serez informé par mail dès que le processus sera terminé.
          </p>
        </div>
      </vx-card>
    </div>

    <!-- SERP LOADING BAR -->
    <div class="center" v-if="startFetching">
      <vx-card class="w-1/2">
        <div class="w-full">
          <p>Analyse SERP en cours...</p>
          <vs-progress :height="10" :percent="loadingPercent" color="primary"
            >primary</vs-progress
          >
        </div>
      </vx-card>
    </div>

    <!-- SERP DATA TABLE -->
    <div v-if="serpResult">
      <div class="vs-row">
        <SerpTable
          :society="selectedSociety"
          :serpData="serpResult"
          v-if="serpResult"
        />
      </div>
    </div>

    <!-- KEYWORD DATA TABLE (SEMANTIC) -->
    <div
      v-if="keywordsResult && !keywordsResult.suggestions && !updateClick"
      class="mt-8"
    >
      <div class="vs-row">
        <SemanticTable
          :keywordsData="keywordsResult"
          @updateKeywordsData="newKeywordSearchVolume"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueCookies from "vue-cookies";
import {AgGridVue} from "ag-grid-vue";
import StatisticsCardLine from "@/components/views/dashboard/statistics-cards/StatisticsCardLine.vue";
import SemanticTable from "@/components/tables/SemanticTable.vue";
import SerpTable from "@/components/tables/SerpTable.vue";
import utilsMixin from "@/mixins/utilsMixin";
import georankerSelect from "@/mixins/formhelpers/georankerSelect";

export default {
	name: "SemanticStatistics",
	mixins: [utilsMixin],
	components: {
		StatisticsCardLine,
		SemanticTable,
		SerpTable
	},
	data() {
		return {
			currentUser: VueCookies.get("userInfo"),
			hasFilter: false,
			loaded: false,
			startFetching: false,
			society: null,
			keywordId: null,
			serpId: null,
			updateClick: false,
			loadingPercent: 0,
			backdoor: 0, // incrementable variable for computed property to reload properly
			apiUrl: this.$store.state.backendApiUrl,
			allSearchEngines: georankerSelect.searchEngines,
			// Data from API
			serpResult: null,
			keywordsSearchVolumeResult: null,
			keywordsIdeasResult: null,
			keywordsResult: null,
			// Query params
			keyword: null,
			searchEngine: null,
			region: null,
			maxResults: null,
			source: null
		};
	},

	/**
	 * Before leaving the route
	 * Save the current society selected
	 * So that we dont need to choose it again while looking for other statistics
	 */
	beforeRouteLeave(to, from, next) {
		if(this.selectedSociety != null) {
			this.$store.dispatch("setPreviousSociety", this.selectedSociety);
			next();
		}
		else next();
	},

	created() {
		//console.log("created");
		this.loaded = false;
		this.getAllSocieties();
		if(this.currentUser.role != 1 && this.currentUser.societies_id != null) {
			this.getUserSociety(this.currentUser.societies_id);
		}

		if(this.$store.state.previousSociety != null) {
			this.selectedSociety = this.$store.state.previousSociety;
		}
	},

	computed: {
		allSocieties() {
			return this.$store.state.societies;
		},
		selectedSociety(){
			return this.$store.state.activeUserSociety;
		},
	},

	watch: {
		selectedSociety: function(data) {
			// Update the last society item
			sessionStorage.setItem("lastSociety", data.id);
			// RESET ALL DATA
			this.selectedData = null;
			this.keywordsResult = null;
			this.serpResult = null;
			if(data["georanker_keyword_data"]) {
				this.keywordsResult = JSON.parse(data["georanker_keyword_data"]);
			}
		},

		serpId: function(data) {
			this.serpResult = null; // reset data
			/*
			 * this.startBarLoader();
			 * this.getSerpData(data, this.selectedSociety.id);
			 */
		}
	},
	methods: {
		/**
		 * Starts a spinning loader
		 */
		openLoading() {
			this.$vs.loading();
			setTimeout(() => this.$vs.loading.close(), 1000);
		},

		/**
		 * RETRIEVE THE USERS SOCIETY HE IS LINKED TO
		 * @param {number} societyId ID of the society
		 */
		getUserSociety(societyId) {
			//console.log("getUserSociety");
			this.$http
				.post(this.apiUrl + "society/get/" + societyId)
				.then(res => (this.selectedSociety = res.data))
				.catch(err => console.error(err));
		},

		/**
		 * Query API to fetch all societies
		 */
		getAllSocieties() {
			this.$store.dispatch("getAllSocieties");
		},

		/**
		 * Creates a new SERP request
		 */
		newSerp() {
			// //console.log("newSerp");
			this.$http
				.post(this.apiUrl + "georanker/new/serp", {
					society_id: this.selectedSociety.id,
					keyword: this.keyword,
					searchEngine: this.searchEngine
					/*
					 * region: this.region,
					 * maxResults: this.maxResults
					 */
				})
				.then(res => (this.serpId = res.data.data.id))
				.catch(err => console.error(err.message));
		},

		/**
		 * Creates a keyword search volume request
		 */
		newKeywordSearchVolume() {
			//console.log("newKeywordSearchVolume");
			this.updateClick = true;
			this.$http
				.post(this.apiUrl + "georanker/new/keyword/searchvolume", {
					society_id: this.selectedSociety.id
				})
				.catch(err => console.error(err.message));
		},

		/**
		 * Creates a keyword ideas request
		 */
		newKeywordIdeas() {
			//console.log("newKeywordIdeas");
			this.$http
				.post(this.apiUrl + "georanker/new/keyword/ideas", {
					society_id: this.selectedSociety.id,
					source: this.source,
					region: this.region
				})
				.then(res => (this.keywordsIdeasResult = res.data))
				.catch(err => console.error(err.message));
		},

		/**
		 * Retrieve serp data for a society given its request ID
		 * @param {number} serpId ID of the wanted SERP request
		 */
		getSerpData(serpId, societyId) {
			//console.log("getSerpData");
			this.$http
				.post(this.apiUrl + "georanker/serp/data", {
					serpId: serpId,
					societyId: societyId
				})
				.then(res => {
					if(!res.data.ready){
						setTimeout(() => this.getSerpData(serpId, societyId), 20000);
					}
					else{
						this.serpResult = res.data;
					}
				})
				.catch(err => console.error(err.message));
		},

		/**
		 * Retrieve keyword data for a society given its request ID
		 * @param {number} keywordId ID of the wanted keyword request
		 */
		getKeywordData() {
			//console.log("getKeywordData");
			this.$http
				.post(this.apiUrl + "georanker/keyword/data", {
					keywordId: "5f184281b45b3b6991198bd2" // TEST PURPOSE ONLY
				})
				.then(res => (this.keywordsResult = res.data.data))
				.catch(err => console.error(err.message));
		},

		/**
		 * Bar loader handler
		 */
		startBarLoader() {
			this.startFetching = true;
			let ref = this;
			let percentUp = setInterval(function() {
				ref.loadingPercent += 0.1;
				//this.dataReset = false
				if(ref.serpResult != null) {
					ref.loadingPercent = 100;
					setTimeout(function() {
						//console.log("finished");
						ref.startFetching = false;
						ref.loadingPercent = 0;
						this.backdoor++;
					}, 2000);
					clearInterval(percentUp);
				}
			}, 300);
		},

		console(data) {
			//console.log(data);
		}
	},
	mounted() {
		/*
		 * =================================================================
		 * NOTE:
		 * Header is not aligned properly in RTL version of agGrid table.
		 * However, we given fix to this issue. If you want more robust solution please contact them at gitHub
		 * =================================================================
		 */
		if(this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(
				".ag-header-container"
			);
			header.style.left = `-${String(
				Number(header.style.transform.slice(11, -3)) + 9
			)}px`;
		}
	}
};
</script>

<style scoped>
.comparing_div {
  margin: 5px;
  align-items: center;
}
.comparing_container {
  display: none;
  margin: 5px;
  background-color: rgb(245, 245, 245);
  border-radius: 5px;
}

.center {
  display: flex;
  justify-content: center;
}

.radial_container {
  display: flex;
}
.filter_container {
  display: flex;
  justify-content: space-between;
}

.txt_align_right {
  text-align: right;
}

.pointer {
  cursor: pointer;
}

.metric_container {
  max-width: 40%;
  min-width: 30%;
}

.txt_low {
  color: #ff4e42;
}

.txt_medium {
  color: #ffa400;
}

.txt_high {
  color: #20e647;
}

.fw-bold {
  font-weight: bold;
}

.small_image {
  width: 100%;
  height: 50px;
  object-fit: cover;
}

.img_thumbnail {
  max-width: 40px;
  max-height: 50px;
  padding: 0 !important;
}

.diag_opp_title {
  font-size: 0.8em;
}

.limit_text {
  font-weight: 500;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.url_box {
  word-break: break-word;
}

.img_thumbnail {
  width: 8.5% !important;
}

.url_box {
  word-break: break-word;
}
</style>
